const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.656 25.84C5.88 25.616 6.16 25.504 6.496 25.504C6.832 25.504 7.112 25.616 7.336 25.84C7.56 26.08 7.672 26.36 7.672 26.68C7.672 27.16 7.48 27.496 7.096 27.688C7.08 27.704 7.04 27.72 6.976 27.736C6.912 27.768 6.848 27.792 6.784 27.808L6.712 27.856C6.712 27.872 6.752 27.92 6.832 28C6.928 28.08 7.008 28.136 7.072 28.168C7.328 28.36 7.64 28.456 8.008 28.456C8.312 28.456 8.568 28.384 8.776 28.24C9.16 28.016 9.448 27.6 9.64 26.992C9.912 26.224 10.168 24.184 10.408 20.872C10.632 17.832 10.872 15.272 11.128 13.192C11.544 9.944 11.784 8.152 11.848 7.816C12.248 5.512 13.024 3.984 14.176 3.232C14.576 2.976 15.016 2.8 15.496 2.704C15.528 2.704 15.6 2.704 15.712 2.704C15.84 2.688 15.944 2.68 16.024 2.68C16.776 2.728 17.4 2.992 17.896 3.472C18.392 3.952 18.64 4.568 18.64 5.32C18.64 5.672 18.528 5.96 18.304 6.184C18.08 6.408 17.8 6.52 17.464 6.52C17.128 6.52 16.848 6.408 16.624 6.184C16.4 5.944 16.288 5.664 16.288 5.344C16.288 4.864 16.48 4.528 16.864 4.336C16.88 4.32 16.92 4.304 16.984 4.288C17.048 4.256 17.104 4.224 17.152 4.192L17.248 4.168C17.248 4.088 17.128 3.984 16.888 3.856C16.616 3.664 16.304 3.568 15.952 3.568C15.248 3.568 14.736 3.984 14.416 4.816C14.224 5.28 14.072 5.92 13.96 6.736C13.864 7.536 13.736 9.008 13.576 11.152C13.352 14.16 13.112 16.712 12.856 18.808C12.536 21.56 12.296 23.352 12.136 24.184C11.672 26.744 10.76 28.36 9.4 29.032C8.984 29.24 8.536 29.344 8.056 29.344C6.904 29.344 6.088 28.848 5.608 27.856C5.416 27.52 5.32 27.136 5.32 26.704C5.32 26.352 5.432 26.064 5.656 25.84Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 21 11)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 14 32)",
  stroke: "#0081CC"
});

const SvgEquationIntegrals6 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-6.b7d5e973.svg";
export { ForwardRef as ReactComponent };